import React from 'react'
import { TooltipProps } from 'recharts'

import { dateFormatter } from '@application/Interfaces/Features/Graph/utils'
import { Nullable } from '@src/Application/Types/Opt'

import { Label, TooltipWrapper } from './CustomTooltip.styled'

export const CustomTooltip = (props: TooltipProps<number, string>): Nullable<JSX.Element> => {
    const { active, payload, label } = props

    if (active && payload && payload.length) {
        return (
            <TooltipWrapper>
                <Label>{dateFormatter(label)}</Label>$ {payload[0].value}
            </TooltipWrapper>
        )
    }

    return null
}
